module.exports = __webpack_public_path__ + "static/media/Camille_0.eb17dba1.jpg";